import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PhpRedirector = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;
    if (path.endsWith(".php")) {
      const newPath = path.replace(/\.php$/, "");
      navigate(newPath + location.search + location.hash, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default PhpRedirector;


export const WhatsappRedirector = () => {
  const location = useLocation();

  useEffect(() => {
    // Redirect to WhatsApp with a predefined message
    const whatsappUrl = "https://wa.me/919176000521?text=Hi";
    window.location.href = whatsappUrl;
  }, [location]);

  return null;
};

export const PreTrialRedirector = ({ channel }) => {
  const location = useLocation();

  useEffect(() => {
    // Preserve any gclid/utm_* params Google Ads autotagging appended, and add
    // our own `channel` so pre-trial can tell "/trial" (web) apart from
    // "/trial2" (Google Ads) — the redirect used to drop this entirely.
    const params = new URLSearchParams(location.search);
    if (channel) params.set("channel", channel);
    window.location.href = `https://pre-trial.ventureintelligence.com/?${params.toString()}`;
  }, [location, channel]);

  return null;
};
